import Login from '../components/admin/Login';

const AdminLoginPage = () => {
  return <Login />;
};

export default AdminLoginPage;
